//core
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSymbolFromCode } from "currency-code-symbol-map";
import { Box, IconButton, Typography } from "@mui/material";

//icons
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import RefreshIcon from "@mui/icons-material/Refresh";

//styles
import { useStyles } from "./styles";

//hooks
import { useUser } from "../../../../../store/common/user/useUser";
import { useAgents } from "../../../../../store/agent/agents/useAgents";
import { useAgents as useAdminAgents } from "../../../../../store/admin/agents/useAgents";

//selectors
import { selectPlayerBalanceData, selectPlayerBalanceError } from "../../../../../store/agent/agents/selectors";
import {
  selectPlayerBalanceData as selectAdmPlayerBalanceData,
  selectPlayerBalanceError as selectAdmPlayerBalanceError,
} from "../../../../../store/admin/agents/selectors";

//components
import FloatFormat from "../FloatFormat";



interface IPlayerBalanceProps {
  data: any;
}

const PlayerBalance: React.FC<IPlayerBalanceProps> = ({
  data,
}): React.ReactElement => {
  const styles = useStyles();

  const { user } = useUser();

  const { getPlayerBalanceById, clearPlayerBalance } = useAgents();
  const adminAgents = useAdminAgents();

  const playerBalance = useSelector(selectPlayerBalanceData);
  const playerBalanceError = useSelector(selectPlayerBalanceError);
  const playerAdmBalance = useSelector(selectAdmPlayerBalanceData);
  const playerAdmBalanceError = useSelector(selectAdmPlayerBalanceError);

  const [wallets, setWallets] = useState<null | object[]>(null);

  useEffect(() => {
    if (!!playerBalance) {
      if (playerBalance.playerId === data.id) {
        setWallets(playerBalance.wallets);
        clearPlayerBalance();
      }
    }
  }, [playerBalance]);

  useEffect(() => {
    if (!!playerAdmBalance) {
      if (playerAdmBalance.playerId === data.id) {
        setWallets(playerAdmBalance.wallets);
        adminAgents.clearPlayerBalance();
      }
    }
  }, [playerAdmBalance]);

  const handleGetBalance = () => {
    getPlayerBalanceById({
      playerId: data.id,
    })
  };

  const handleAdmGetBalance = () => {
    adminAgents.getPlayerBalanceById({
      playerId: data.id,
    });
  };

  console.log('wallets: ', wallets)

  return (
    <Box>
      {!!wallets ? (
        <>
          {<Box className={styles.block}>
            {wallets.map((wallet: any, index: number) => (
              <span key={index}>
	              <Typography className={styles.ltr} component={'div'} variant={'body2'}>
				          {getSymbolFromCode(wallet.currency) ? (<Box>{`${wallet.currency} - `}{getSymbolFromCode(wallet.currency)} </Box>) : `${wallet.currency} `}
		              <Box>
					          <FloatFormat value={wallet.balance} />
				          </Box>
			          </Typography>
                {index < wallets.length - 1 && ', '}
              </span>
            ))}

            {user.user.namespace === 'agent' && (
              <IconButton
                className={styles.refresh}
                size="small"
                aria-label="settings"
                onClick={handleGetBalance}
              >
                <RefreshIcon fontSize="small" />
              </IconButton>
            )}
            {user.user.namespace === 'admin' && (
              <IconButton
                className={styles.refresh}
                size="small"
                aria-label="settings"
                onClick={handleAdmGetBalance}
              >
                <RefreshIcon fontSize="small" />
              </IconButton>
            )}
          </Box>}
        </>
      ) : (<>
        {user.user.namespace === 'agent' && (
          <IconButton
            color="primary"
            size="small"
            onClick={handleGetBalance}
          >
            <RemoveRedEyeIcon fontSize="small" color="primary" />
          </IconButton>
        )}
        {user.user.namespace === 'admin' && (
          <IconButton
            color="primary"
            size="small"
            onClick={handleAdmGetBalance}
          >
            <RemoveRedEyeIcon fontSize="small" color="primary" />
          </IconButton>
        )}
      </>)}
    </Box>
  );
};

export default PlayerBalance;
